/* Teeshaa shop pages: sort auto-submit, filter panel housekeeping, "Show more" in place, gentle arrival.
   Everything here is an enhancement: without it, sort has an Apply button and "Show more" is a page link. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function arrive(root, items) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    // anything already on screen lights at once
    requestAnimationFrame(function () {
      items.forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); });
    });
  }

  function init(root) {
    if (root.__sx) return; root.__sx = true;
    if (!reduce) root.classList.add('is-armed');
    arrive(root, [].slice.call(root.querySelectorAll('.sx-card, .sx-tile')));

    var sort = root.querySelector('[data-sx-sort]');
    if (sort) sort.addEventListener('change', function () {
      var f = sort.form; if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });

    // keep the URL clean: drop empty fields on submit
    var form = root.querySelector('[data-sx-form]');
    if (form) form.addEventListener('submit', function () {
      [].forEach.call(form.querySelectorAll('input[type=number]'), function (i) { if (i.value === '') i.disabled = true; });
    });

    // filter panel: close on Escape and on outside click
    var det = root.querySelector('[data-sx-filter]');
    if (det) {
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && det.open) { det.open = false; det.querySelector('summary').focus(); } });
      document.addEventListener('click', function (e) { if (det.open && !det.contains(e.target)) det.open = false; });
    }

    // browse / sort panels: one open at a time, Escape and the close button shut them
    var dds = [].slice.call(root.querySelectorAll('[data-sx-dd]'));
    dds.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; });
        document.documentElement.classList.toggle('sx-locked', dds.some(function (o) { return o.open; }) && innerWidth < 750);
      });
      var x = d.querySelector('[data-sx-close]');
      if (x) x.addEventListener('click', function () { d.open = false; d.querySelector('summary').focus(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dds.forEach(function (d) { if (d.open) { d.open = false; d.querySelector('summary').focus(); } });
    });

    // cart: steppers and typed quantities update the cart in place (the form posts to /cart without script)
    var cartForm = root.querySelector('[data-sx-cart]');
    if (cartForm) {
      var upd;
      var send = function () {
        clearTimeout(upd);
        upd = setTimeout(function () {
          cartForm.classList.add('is-busy');
          var fd = new FormData(cartForm); fd.delete('checkout'); fd.append('update', '1');
          fetch(cartForm.action, { method: 'POST', body: fd, credentials: 'same-origin' })
            .then(function () { location.reload(); })
            .catch(function () { cartForm.classList.remove('is-busy'); });
        }, 450);
      };
      cartForm.addEventListener('click', function (e) {
        var b = e.target.closest('.sx-qty__b'); if (!b) return;
        var i = b.parentNode.querySelector('input'); var v = Math.max(0, (parseInt(i.value, 10) || 0) + (+b.dataset.step));
        i.value = v; send();
      });
      cartForm.addEventListener('change', function (e) { if (e.target.matches('.sx-qty input')) send(); });
      cartForm.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('.sx-qty input')) { e.preventDefault(); send(); } });
    }

    // show more in place
    var grid = root.querySelector('[data-sx-grid]');
    var more = root.querySelector('[data-sx-more]');
    if (grid && more) more.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sx-next]'); if (!a) return;
      e.preventDefault();
      a.setAttribute('aria-busy', 'true'); a.textContent = 'Loading';
      fetch(a.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nGrid = doc.querySelector('[data-sx-grid]'); var nMore = doc.querySelector('[data-sx-more]');
        var added = [];
        if (nGrid) [].forEach.call(nGrid.children, function (li) {
          if (li.classList.contains('sx-band')) return;
          var node = document.importNode(li, true); grid.appendChild(node); added.push(node);
        });
        if (nMore) {
          // keep "Previous" off: in place, the earlier pieces are already above
          var prev = nMore.querySelector('.sx-link--back'); if (prev) prev.remove();
          more.innerHTML = nMore.innerHTML;
        } else more.remove();
        arrive(root, added);
        var first = added[0] && added[0].querySelector('a'); if (first) first.focus({ preventScroll: true });
      }).catch(function () { location.href = a.href; });
    });
  }

  // hover effects pause while the page scrolls, so frames don't flicker as they slide under a still pointer
  var scT, html = document.documentElement;
  addEventListener('scroll', function () {
    if (!html.classList.contains('sx-scrolling')) html.classList.add('sx-scrolling');
    clearTimeout(scT); scT = setTimeout(function () { html.classList.remove('sx-scrolling'); }, 180);
  }, { passive: true });

  function boot() { [].forEach.call(document.querySelectorAll('[data-sx]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
